module.exports = __webpack_public_path__ + "img/width_facing_hood.0460f5dd.png";